module.exports = __webpack_public_path__ + "media/camel.716a3775.mp3";